/**
 * Build-time config, read from Vite env (`VITE_*` variables).
 *
 * Populated from Terraform outputs — see ../.env.example.
 */

function required(name: string, value: string | undefined): string {
  if (!value || value.startsWith("replace-me")) {
    throw new Error(
      `Missing build-time env var ${name}. Copy .env.example to .env.production and fill from terraform outputs.`,
    );
  }
  return value;
}

export const config = {
  appOrigin: required("VITE_APP_ORIGIN", import.meta.env.VITE_APP_ORIGIN),
  cognitoDomain: required("VITE_COGNITO_DOMAIN", import.meta.env.VITE_COGNITO_DOMAIN),
  cognitoClientId: required("VITE_COGNITO_CLIENT_ID", import.meta.env.VITE_COGNITO_CLIENT_ID),
  apiBaseUrl: required("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
};
